import React from 'react';
import PropTypes from 'prop-types';
import bindAll from 'lodash.bindall';
import { connect } from 'react-redux';
import { projectTitleInitialState } from '../reducers/project-title';
import { lmsDataService } from '../reducers/99lmsdatashare';

class SaveTo99Lms extends React.Component {

    constructor(props) {
        super(props);
        bindAll(this, [
            'fnSaveTo99LMS'
        ]);
    }

    render() {
        const {
            children
        } = this.props;
        return children(
            this.props.className,
            this.fnSaveTo99LMS
        );
    }

    fnConvertBlobToFile(content) {
        const myPromise = new Promise((resolve, reject) => {
            resolve(new File([content], this.props.projectFilename), { type: 'application/x.scratch.sb3' });
        });
        return myPromise;
    }

    fnSaveTo99LMS() {

        const viewMode = lmsDataService.getData('viewMode');
        if (viewMode) {
            if (viewMode['viewOnly']) {
                alert('You cannot save the file in view only mode');
                return
            }
        }

        const editMode = lmsDataService.getData('editMode');

        if (!editMode) {
            alert('This option not available right now');
            return
        }

        // if (lmsDataService.getData('independentProject')) {
        //     if (!lmsDataService.getData('pathToSave')){

        //         const message = {
        //             status: 'needFileName'
        //         };

        //         if (window.parent) {
        //             window.parent.postMessage(message, '*');
        //         }
        
        //         if (window.opener) {
        //             window.opener.postMessage(message, '*');
        //         }
        //         return;
        //     }
        // }

        this.props.saveProjectSb3().then(content => {

            if (this.props.onSaveFinished) {
                this.props.onSaveFinished();
            }

            setTimeout(() => {

                this.fnConvertBlobToFile(content).then(function (file) {

                    var xhr = new XMLHttpRequest();
                    xhr.open("POST", lmsDataService.getData('API_URL'), true);

                    var formdata = new FormData();
                    formdata.append("file", file);

                    var pathToSave = lmsDataService.getData('pathToSave');
                    var fileName;
                    if(pathToSave) {
                        fileName = pathToSave.split('/')[pathToSave.split('/').length - 1];
                        if(!fileName){
                            fileName = editMode['filePath'].split('/')[editMode['filePath'].split('/').length - 1];
                        }
                    }

                   

                   

                    if (editMode['mode'] == 'newFile' || editMode['mode'] == 'editTeacherSharedFile') {
                        if(pathToSave){
                            pathToSave = pathToSave.replace("files/", '');
                        }
                        formdata.append("pathToBeSave", (pathToSave?(pathToSave).replace("/" + fileName, ''):'scratchQuestionScratchFiles'));
                    } else if (editMode['mode'] == 'edit') {
                        if(pathToSave){
                            pathToSave = pathToSave.replace("files/", '');
                        }
                        formdata.append("pathToBeSave", (pathToSave?(pathToSave.replace("/" + fileName, '')):'scratchQuestionScratchFiles'));
                    }

                    if(fileName) {
                        formdata.append("fileName", fileName);
                        // formdata.append("overwrite", true);
                    }

                    xhr.send(formdata);
                    xhr.onreadystatechange = function () {
                        if (xhr.readyState == 4 && xhr.status == 200) {

                            lmsDataService.setData(true, 'fileSaved');
                            if(pathToSave){
                                const path = pathToSave.replace(fileName, xhr.response.replace('"', '').replace('"', ''));                               
                                lmsDataService.setData( path, 'pathToSave')
                                editMode['filePath'] = lmsDataService.getData('S3_BASE_URL') + path
                                lmsDataService.setData(editMode, 'editMode')
                            }
                            const message = {
                                status: 'fileSaved',
                                value: (lmsDataService.getData('pathToSave')?lmsDataService.getData('pathToSave'):'files/' + 'scratchQuestionScratchFiles/' + xhr.response.replace('"', '').replace('"', ''))
                            };

                            if (window.parent) {
                                window.parent.postMessage(message, '*');
                            }
                    
                            if (window.opener) {
                                window.opener.postMessage(message, '*');
                            }
                            
                        }
                    };

                })
            }, 300);
        });
    }

}

const getProjectFilename = (curTitle, defaultTitle) => {
    let filenameTitle = curTitle;
    if (!filenameTitle || filenameTitle.length === 0) {
        filenameTitle = defaultTitle;
    }
    return `${filenameTitle.substring(0, 100)}.sb3`;
};

SaveTo99Lms.propTypes = {
    children: PropTypes.func,
    className: PropTypes.string,
    saveProjectSb3: PropTypes.func,
    projectFilename: PropTypes.string,
};

const mapStateToProps = state => ({
    saveProjectSb3: state.scratchGui.vm.saveProjectSb3.bind(state.scratchGui.vm),
    projectFilename: getProjectFilename(state.scratchGui.projectTitle, projectTitleInitialState)
});

export default connect(
    mapStateToProps,
    () => ({}) // omit dispatch prop
)(SaveTo99Lms);